import React from "react";
import "./Solution_That_Fit_Needs.css";
import Common_Title_1 from "../../common_components/common_title_1/Common_Title_1";

const Solution_That_Fit_Needs = () => {
  const data = [
    {
      no: "01",
      title: "Register / Sign Up",
      subtext: "Create your account in just a few clicks to get started.",
    },
    {
      no: "02",
      title: "Buy Subscription Plan",
      subtext: "Select the plan that best fits your needs and unlock access.",
    },
    {
      no: "03",
      title: "Access Interactive courses",
      subtext:
        "Enjoy structured Interactive courses designed to help you learn anytime, anywhere.",
    },
    {
      no: "04",
      title: "Grow & Achieve",
      subtext:
        "Track your progress, enhance your skills, and reach your goals with confidence.",
    },
  ];

  return (
    <section className="Solution_That_Fit_Needs">
      <div className="container">
        <div className="content_div">
          <Common_Title_1
            titleText={"Solutions that Fit Your Needs"}
            subText={
              "Choose, learn, and grow with flexible plans and trusted support."
            }
          />

          <div className="steps_cards_holder">
            <div className="row">
              {data?.map((item) => {
                return (
                  <div className="col-xl-3 col-lg-4 col-sm-6 mb-4">
                    <div className="step_card">
                      <div className="setp_content_div">
                        <p className="no_text">{item?.no}</p>
                        <p className="title_text">{item?.title}</p>
                        <p className="descn_text">{item?.subtext}</p>

                        <div className="overlay"></div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solution_That_Fit_Needs;
